import { svg } from "config/svgStyles";

export const tabs = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
};

export const tab = ({ isSelected, UIVersion }) => {
  const selectedColor =
    isSelected && UIVersion === 2 ? "primary" : isSelected && "black";
  const unselectedColor =
    !isSelected && UIVersion === 2 ? "black" : !isSelected && "primary";
  return {
    padding: "10px 30px",
    backgroundColor: isSelected ? "white" : "transparent",
    borderRadius: "20px 20px 0px 0px",
    color: isSelected ? selectedColor : unselectedColor,
    cursor: "pointer",
    fontFamily: "body",
    fontWeight: "body",
    fontSize: "20px",
    letterSpacing: "0.05em",
    lineHeight: "1",
    mt: "36px",
    position: "relative",
    textTransform: "uppercase",
    transition: "background-color 0.3s",
    whiteSpace: "nowrap",

    "&:hover, :focus": {
      backgroundColor: "white",
    },
  };
};

export const tabTitle = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  pointerEvents: "none",
};

export const tabTitleV2 = ({ isSelected }) => ({
  ...tabTitle,
  display: "flex",
  gap: "10px",

  ...svg(isSelected ? "primary" : "black"),
});

export const checkmark = {
  width: "16px",
  position: "absolute",
  bottom: "100%",
  left: "50%",
  margin: "0 0 10px -8px",
  pointerEvents: "none",
};

export const previousButton = {
  backgroundColor: "white",
  borderRadius: "0 20px 0px 0px",
  color: "black",
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0",
  width: "76px",
  height: "40px",
  opacity: 1,
  transition: "opacity .3s",
  mt: "36px",

  "&:disabled, &[disabled]": {
    cursor: "not-allowed",
    opacity: 0,
    pointerEvents: "none",
  },
};

export const nextButton = {
  ...previousButton,
  borderRadius: "20px 0px 0px 0px",
  left: "auto",
  right: "0",
};

export const desktopContainer = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
};

export const mobileButtonContainer = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  flexGrow: "1",
  flexShrink: "1",
};
